import Component from './TwitterAnalyticsPublicHeader.vue'
export default Component
